import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { awsLocation, businessIdHeader, cssFormInput, cssFormInputButton, cssFormInputFile, cssFormInputLabel, cssFormInputText, fetchSignedMessage, fileFieldType, getSessionValue, httpOKsuccess, https, isLoggedIn, postAttachment, postMethod, s3resource, standardMinusTextLength, textField } from './Library';



export class VoucherSender extends Component {
	constructor(props) {
		super(props)
		this.state = {
			businessId: '',
			consumerDeviceId: '',
			businessVoucherNumber: '',
			title: '',
			text: '',
			attachment: null,
			attachmentPath: '',
			validFrom: null,
			expiry: null,
			redeemed: null,
			filterDimensions: [],
			loading: true,
			helpVisible: false,
			submitButtonDisabled: false,
			errorDescription: '',
			errorTitle: '',
			filterProcedureIds: [],
			recipients: props.recipients
		};
		this.handleInputChange = this.handleInputChange.bind(this);
	}

	async componentDidMount() {
		await isLoggedIn();
	}

	setDateControlToCurrentDateTime(fieldIdentifier) {
		var tzoffset = (new Date()).getTimezoneOffset() * 60000;
		var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
		var localISOTimeWithoutSeconds = localISOTime.slice(0, 16);

		var datePicker = document.querySelector('input[name=' + fieldIdentifier + ']');
		datePicker.value = localISOTimeWithoutSeconds;
		this.setState({
			[fieldIdentifier]: localISOTimeWithoutSeconds
		})
	}

	setDateControlToThreeMonthsInFuture(fieldIdentifier) {
		var tzoffset = (new Date()).getTimezoneOffset() * 60000;
		var localOffsetTime = new Date(Date.now() - tzoffset);
		localOffsetTime.setMonth(localOffsetTime.getMonth() + 3);
		var localISOTime = (localOffsetTime).toISOString().slice(0, -1);
		var localISOTimeWithoutSeconds = localISOTime.slice(0, 16);

		var datePicker = document.querySelector('input[name=' + fieldIdentifier + ']');
		datePicker.value = localISOTimeWithoutSeconds;
		this.setState({
			[fieldIdentifier]: localISOTimeWithoutSeconds
		})
	}

	handleInputChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.type === 'number' ? parseInt(target.value) : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	handleDropDownChange = (e, data) => {
		const name = data.name;
		if (data.action == 'select-option') {
			if (!this.state.filterProcedureIds.some(fp => fp === data.option.value)) {
				this.setState({ filterProcedureIds: [...this.state.filterProcedureIds, data.option.value] });
			}
		}

		if (data.action == 'clear') {
			this.setState({ filterProcedureIds: this.state.filterProcedureIds.filter(fp => fp !== data.removedValue.value) });
		}

		if (data.action == 'remove-value') {
			this.setState({ filterProcedureIds: this.state.filterProcedureIds.filter(fp => fp !== data.removedValue.value) });
		}
	}

	handleFileChange = (event) => {
		this.setState({
			attachment: event.target.files[0]
		})
	}

	handleSubmit = (event) => {
		event.preventDefault();

		try {
			const isValid = this.handleValidation();

			if (isValid) {
				var responseLabel = document.getElementById("voucherSentResponse");
				this.setState({ loading: true, submitButtonDisabled: true });
				ReactDOM.render("", responseLabel);

				var voucher = {
					businessId: getSessionValue(businessIdHeader),
					businessVoucherNumber: this.state.businessVoucherNumber,
					title: this.state.title,
					text: this.state.text,
					attachment: this.state.attachmentPath,
					validFrom: this.state.validFrom,
					expiry: this.state.expiry,
					redeemed: this.state.redeemed
				}

				if (this.state.attachment != null) {
					this.state.attachmentPath = postAttachment(this.state.attachment);
					voucher.attachmentPath = https + process.env.REACT_APP_MESSAGE_BUCKET_NAME + s3resource + process.env.REACT_APP_AWS_REGION + awsLocation + this.state.attachmentPath
				}

				var voucherAndConsumerDevices = {
					consumerDeviceIds: this.state.recipients,
					voucher: voucher
				}

				this.sendVoucherAndUpdateReturnMessage(voucherAndConsumerDevices);
			}
		}
		catch (error) {
			this.setState({ loading: false, submitButtonDisabled: false });
			ReactDOM.render(<label className={cssFormInputLabel}>We didn't even try to send the voucher. Please try again later.</label >, responseLabel);
		}
	}

	async sendVoucherAndUpdateReturnMessage(voucherAndUserFilters) {
		try {
			var responseLabel = document.getElementById("voucherSentResponse");
			const response = await fetchSignedMessage(JSON.stringify(voucherAndUserFilters), 'voucher/consumerdevices', postMethod);
			if (response.status == httpOKsuccess) {
				const data = await response.json();
				ReactDOM.render(<label className={cssFormInputLabel}>{data.length} vouchers sent succesfully.</label>, responseLabel);
			} else {
				ReactDOM.render(<label className={cssFormInputLabel}>Voucher sending failed. Please try again later.</label >, responseLabel);
			}
		}
		catch (error) {
			ReactDOM.render(<label className={cssFormInputLabel}>Voucher sending failed. Please try again later.</label >, responseLabel);
		}
		finally {
			this.setState({ loading: false, submitButtonDisabled: false });
		}

	}

	handleValidation() {
		let validated = true;

		if (!this.validateTextContainsText(this.state.text, "errorDescription", "A message requires text")) {
			validated = false;
		}

		if (!this.validateTextContainsText(this.state.title, "errorTitle", "A message requires a title")) {
			validated = false;
		}

		return validated;
	}

	validateTextContainsText(valueToValidate, stateForErrorMessage, errorMessage) {
		if (valueToValidate.length == 0) {
			this.setState({ [stateForErrorMessage]: errorMessage });
			return false;
		} else {
			this.setState({ [stateForErrorMessage]: "" });
			return true;
		}
	}

	render() {

		return (
			<>
				<form className={cssFormInput} onSubmit={this.handleSubmit}>

					<label className={cssFormInputLabel}>
						Title:
						<input type={textField} name="title" value={this.state.title} onChange={this.handleInputChange} className={cssFormInputText} maxLength={standardMinusTextLength} />
					</label>{this.state.errorTitle && <p className="error">{this.state.errorTitle}</p>}

					<label className={cssFormInputLabel}>
						Text:
						<input type={textField} name="text" value={this.state.text} onChange={this.handleInputChange} className={cssFormInputText} maxLength={standardMinusTextLength} />
					</label>{this.state.errorDescription && <p className="error">{this.state.errorDescription}</p>}

					<label className={cssFormInputLabel}>
						Voucher Image File:
						<input type={fileFieldType} name="attachment" onChange={this.handleFileChange} className={cssFormInputFile} />
					</label>

					<label className={cssFormInputLabel}>
						Valid From:
						<input type="datetime-local" name="validFrom" value={this.state.validFrom} onChange={this.handleInputChange} className={cssFormInputText} />
					</label>

					<label className={cssFormInputLabel}>
						Expiry:
						<input type="datetime-local" name="expiry" value={this.state.expiry} onChange={this.handleInputChange} className={cssFormInputText} />
					</label>

					<input type="submit" value="Send Vouchers" className={cssFormInputButton} disabled={this.state.submitButtonDisabled} />
					<div id="voucherSentResponse" />
				</form>
			</>
		);
	}
}
